import { connect } from 'react-redux';
import { RootState } from '@iwProvider/configureStore';
import { getTopUpStatus } from '../NewOutstandingView.helpers';
import { NotYetTopUpEligible } from './TopUpStatusMessages/NotYetTopUpEligible';
import { TopUpPending } from './TopUpStatusMessages/TopUpPending';
import { TopUpDeclined } from './TopUpStatusMessages/TopUpDeclined';
import { NotTopUpEligible } from './TopUpStatusMessages/NotTopUpEligible';
import { TProductType } from '../../../dashboard/Dashboard.types';
import { PreApproved } from './TopUpStatusMessages/PreApproved';

const mapStateToProps = (state: RootState, { productType }: TProps) => {
    return {
        topUpStatus: getTopUpStatus(state, productType)
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;
type TProps = { accountId: string; productType: TProductType };

const RequestMoreFundsPanel = ({
    topUpStatus,
    accountId
}: TProps & PropsFromRedux) => {
    switch (topUpStatus) {
        case 'NOT_YET_TOPUP_ELIGIBLE':
            return <NotYetTopUpEligible accountId={accountId} />;
        case 'TOPUP_PENDING':
            return <TopUpPending />;
        case 'TOPUP_DECLINED':
            return <TopUpDeclined />;
        case 'PRE_APPROVED':
            return <PreApproved accountId={accountId} />;
        default:
            return <NotTopUpEligible />;
    }
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RequestMoreFundsPanel);
